import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { allLocalStorage, allSessionStorage } from 'src/app/shared/constantes';
import {DigoService} from '../../../services/digo.service';

@Component({
    selector: 'app-jwt',
    templateUrl: './jwt.component.html',
    styleUrls: ['./jwt.component.css'],
    standalone: false
})
export class JwtComponent implements OnInit {

    constructor(
        private activatedRoute: ActivatedRoute, 
        private router: Router, 
        private digoService: DigoService
    ) { }

    ngOnInit(): void {
        console.log('JwtComponent');
        
        const jwt = this.activatedRoute.snapshot.paramMap.get('jwt');
        const brand = this.activatedRoute.snapshot.paramMap.get('brand');
        const state = this.activatedRoute.snapshot.paramMap.get('state');

        if (jwt !== undefined && jwt !== null && jwt !== '') {
            // Se guardan temporalmente el estado de las comunicaciones
            /*             const savedNotificationHome = localStorage.getItem(allLocalStorage.notificationHome);
                        console.log('savedNotificationHome -->', savedNotificationHome); */

            const notificationHome = localStorage.getItem(allLocalStorage.notificationHome);
            const notificationKeys = Object.keys(localStorage).filter(key => key.startsWith('new_'));
            const notificationFlags = {};
            notificationKeys.forEach(key => {
                notificationFlags[key] = localStorage.getItem(key);
            });

            console.log('🔵 ANTES del clear:');
            console.log('  notificationHome:', notificationHome);
            console.log('  notificationFlags:', notificationFlags);

            this.digoService.setPDV(null);
            sessionStorage.removeItem(allSessionStorage.simyoEarthquakeCoShown);
            localStorage.clear();

            // Restaurar las notificaciones
            if (notificationHome !== null) {
                localStorage.setItem(allLocalStorage.notificationHome, notificationHome);
            }
            Object.keys(notificationFlags).forEach(key => {
                localStorage.setItem(key, notificationFlags[key]);
            });

            console.log('🟢 DESPUÉS de restaurar:');
            console.log('  notificationHome:', localStorage.getItem(allLocalStorage.notificationHome));
            console.log('  Flags restaurados:', Object.keys(localStorage).filter(k => k.startsWith('new_')));

            localStorage.setItem(allLocalStorage.accessToken, jwt);

            this.digoService.setPDV(null);
            this.digoService.setRenewPDV(true);
            this.router.navigate(['/' + (brand ? brand : '') + (state ? '/' + state : '')]);
        } else {
            this.router.navigate(['/']);
        }
    }

}
